<template>
  <div class="readyFlowsInsightSanitizedContent" v-html="sanitizedContent" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import sanitizeHtml from "sanitize-html";

interface Props {
  content: string | null;
}

const { content } = defineProps<Props>();

const sanitizedContent = computed(() =>
  sanitizeHtml(content ?? "", {
    allowedTags: ["section", "div", "ul", "ol", "li", "p", "span", "b", "strong"],
  })
);
</script>

<style>
@reference "vue-app/assets/scss/main.css";

.readyFlowsInsightSanitizedContent {
  /* Fallback styles for plain text when sanitizedContent has no HTML tags */
  @apply tw:text-default-700 tw:body-2;
}

.readyFlowsInsightSanitizedContent p,
.readyFlowsInsightSanitizedContent li,
.readyFlowsInsightSanitizedContent span {
  @apply tw:body-2 tw:text-default-700;
}

.readyFlowsInsightSanitizedContent strong {
  @apply tw:body-2--bold  tw:text-default-700;
}

.readyFlowsInsightSanitizedContent ul,
.readyFlowsInsightSanitizedContent ol {
  @apply tw:ml-5 tw:py-2;
}

.readyFlowsInsightSanitizedContent ul {
  @apply tw:list-disc;
}

.readyFlowsInsightSanitizedContent ol {
  @apply tw:list-decimal;
}

.readyFlowsInsightSanitizedContent li {
  @apply tw:list-item tw:list-[revert];
}
</style>
